import React from "react";
import Box from "@mui/material/Box";
import OperationsManagementEmployeeDetails from "./OperationsManagementEmployeeDetails";
import TerritoryAssignmentsCard from "./TerritoryAssignmentsCard";
import EmployeeTEAM from "../EmployeeTEAM";
import EmployeeComplaintCard from "../EmployeeComplaintCard";
import EmployeePto from "../EmployeePto";

interface OperationsManagementProfileProps {
  employeeId: number;
  employeeRoleId?: number; //needed if can view pto card
  internetUserId: number;
  canViewTeamCard?: boolean;
  canViewFeedbackCard?: boolean;
  canEditFeedbackCard?: boolean;
  canViewPtoCard?: boolean;
}

const OperationsManagementProfile = ({
  employeeId,
  internetUserId,
  employeeRoleId,
  canViewTeamCard = false,
  canViewFeedbackCard = false,
  canEditFeedbackCard = false,
  canViewPtoCard = false,
}: OperationsManagementProfileProps) => {
  const isRenderingPtoCard =
    canViewPtoCard && employeeRoleId !== 0 && employeeRoleId !== undefined && employeeRoleId !== null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <OperationsManagementEmployeeDetails employeeId={employeeId} />
      <TerritoryAssignmentsCard employeeId={employeeId} />
      {canViewTeamCard && <EmployeeTEAM internetUserId={internetUserId} overrideCellWidth />}
      {canViewFeedbackCard && (
        <EmployeeComplaintCard
          employeeId={employeeId}
          cardTitleOverride="Employee Feedback"
          viewOnly={!canEditFeedbackCard}
        />
      )}
      {isRenderingPtoCard && (
        <EmployeePto employeeId={employeeId} employeeRoleId={employeeRoleId} internetUserId={internetUserId} />
      )}
    </Box>
  );
};

export default OperationsManagementProfile;
